// CurrentSheetsList.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import SheetPreview from "../Common/SheetPreview";
import DownloadButton from "../Common/DownloadButton";

export default function CurrentSheetsList({ companyId }) {
  const [sheets, setSheets] = useState([]);
  const [selected, setSelected] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const fetchSheets = async () => {
    try {
      const res = await api.get("/printing/sheets", {
        params: { companyId },
      });
      setSheets(res.data.elements || []);
    } catch (err) {
      console.error("Ошибка загрузки листов:", err);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchSheets();
      const interval = setInterval(fetchSheets, 5000);
      return () => clearInterval(interval);
    }
  }, [companyId]);

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    if (selected.length === sheets.length) setSelected([]);
    else setSelected(sheets.map((x) => x.id));
  };

  const toggleExpand = (id) => setExpanded(expanded === id ? null : id);

  const moveToCutting = async () => {
    if (selected.length === 0) return;
    await api.patch("/printing/sheets/move-to-cutting", {
      layoutingSheetsIds: selected,
    });
    setSelected([]);
    fetchSheets();
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <button
            className="btn btn-warning me-2"
            disabled={selected.length === 0}
            onClick={moveToCutting}
          >
            Передать на резку ({selected.length})
          </button>
        </div>
      </div>

      {sheets.length > 0 && (
        <div className="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={selected.length === sheets.length}
            ref={(el) =>
              el &&
              (el.indeterminate =
                selected.length > 0 && selected.length < sheets.length)
            }
            onChange={toggleSelectAll}
          />
          <span>
            Выбрано {selected.length} из {sheets.length}
          </span>
        </div>
      )}

      {sheets.map((s) => (
        <div key={s.id} className="border rounded p-2 mb-2">
          <div
            className="d-flex justify-content-between"
            style={{ cursor: "pointer" }}
            onClick={() => toggleExpand(s.id)}
          >
            <div className="d-flex">
              <input
                type="checkbox"
                className="form-check-input me-3"
                checked={selected.includes(s.id)}
                onClick={(e) => e.stopPropagation()}
                onChange={() => toggleSelect(s.id)}
              />
              <div>
                <div className="fw-bold">{s.name}</div>
                <small className="text-muted">
                  {new Date(s.creationTime).toLocaleString()}
                </small>
              </div>
              <div>
                {s.cutMachineType == 2 && (
                  <span className="ms-2 badge bg-primary">Плоттер</span>
                )}
                {s.isNew === true && (
                  <span className="ms-2 badge bg-success">Новый</span>
                )}
              </div>
            </div>

            <div className="col-md-3 col-6">
              <small className="text-muted d-block">Создатель:</small>
              <div>{s.createdBy}</div>
            </div>
          </div>

          {expanded === s.id && (
            <div className="card-footer d-flex flex-column gap-2">
              <div className="mt-2">
                <SheetPreview jobId={s.jobId} />
              </div>

              <div className="d-flex flex-wrap gap-2">
                <DownloadButton
                  endpoint={`/printing/sheets/download/${s.id}`}
                  buttonLabel="Скачать .pdf"
                  method="post"
                  defaultFileName="sheet.pdf"
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}